
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment mettre en place une bonne stratégie de Netlinking ?",
    description:
      "Découvrez comment élaborer une stratégie de Netlinking efficace pour renforcer l’autorité de votre site, améliorer son référencement et attirer plus de visiteurs.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
